import type {PlaceDetails} from '@Components/google-map/google-map.types';
import type {InputFieldSize} from '@Components/input-field-v2/input-field.types';

export interface GoogleMapAutocompleteProps {
  onPlaceSelect: (place: PlaceDetails | undefined) => void;
  onUpdateSearch: (value: string) => void;
  searchVal?: string;
  inputFieldSize?: InputFieldSize;
  isLocationUpdating?: boolean;
}

export const autocompleteSearchID = 'google-map-autocomplete';
